
import React, { useEffect, useMemo, useState } from 'react';
import { FormTemplateAPI } from '../../../api/FormTemplateAPI';
import styles from '../../../styles/modules/RegistrationSetup.module.css';
import CustomContainerLoader from '../../CustomComponents/CustomContainerLoader/CustomContainerLoader';
import CustomCheckbox from '../../CustomComponents/CustomCheckbox/CustomCheckbox';
import { Accordion, AccordionDetails, AccordionSummary, Radio, TextField, Typography } from '@mui/material';
import creditCardImg from '../../../assets/images/transaction.png'
import { getLogoByPaymentMethodName } from '../../../util/PaymentUtil';

const FormPaymentOptions = ({ feeDetails, paymentMethod, setPaymentMethod, formTemplateId }) => {
    const [paymentMethodDetails, setPaymentMethodDetails] = useState({ offline_payment: {}, online_payment: [] });
    const [isLoading, setIsLoading] = useState(false);

    const getAllAttachedPaymentMethod = async () => {
        try {
            setIsLoading(true);
            const response = await FormTemplateAPI.getAllAttachedPaymentMethod(formTemplateId);
            setPaymentMethodDetails({
                online_payment: response.Data.onlinePaymentMethods,
                offline_payment: response.Data.offlinePaymentMethods
            });
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getAllAttachedPaymentMethod();
    }, [])



    const handleCollectPaymentMethod = (key, value) => {
        if (key === 'online_payment') {
            setPaymentMethod({ type: key })
        } else {
            setPaymentMethod({ id: value.id, type: key, name: value.name, desc: value.desc })
        }
    };

    const totalAmount = useMemo(() => {
        return feeDetails.reduce((sum, curr) => sum + parseFloat(curr.feeAmount || 0), 0);
    }, [feeDetails]);

    const radioBtnStyle = {
        '&.Mui-checked': {
            color: 'var(--hoverColorBold)', // checked color
        },
        '&.Mui-checked ~ .MuiFormControlLabel-label': {
            color: 'var(--hoverColorBold)',
        },
    };


    if (isLoading) {
        return <CustomContainerLoader />
    }

    return (
        <div className={styles['roster_payment_container']}>
            <div className={styles['form_payment_method_list']}>
                {((paymentMethodDetails.online_payment.length != 0) || (paymentMethodDetails.offline_payment.id)) &&
                    <div className={styles['form_overview_payment_methods']}>
                        <h2>Choose Payment Method</h2>
                        <div className={styles['form_payment_method_list']}>
                            {
                                Object.entries(paymentMethodDetails)?.map(([key, value]) =>
                                    <React.Fragment key={key}>
                                        {((key === 'online_payment' && value.length != 0) || (key === 'offline_payment' && value.length != 0)) &&
                                            <div className={styles['form_payment_method_card']}>
                                                <Radio sx={radioBtnStyle} disabled={totalAmount === 0} checked={paymentMethod?.type === key} onChange={(e) => setPaymentMethod({ id: value.id, type: key })} />
                                                <p className={totalAmount === 0 ? `${styles['form_payment_method_title']} ${styles['disabled']}` : styles['form_payment_method_title']}>{key?.replaceAll("_", " ")}</p>
                                            </div>}
                                        {paymentMethod?.type == key &&
                                            <div className={styles['online_payment_method_list']}>
                                                {value?.map((pm, index) =>
                                                    <Accordion
                                                        expanded={pm.id === paymentMethod.id}
                                                        elevation={0}
                                                        sx={{
                                                            boxShadow: 'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
                                                            borderRadius: '15px',
                                                            height: 'max-content',
                                                            minHeight: 0,
                                                            margin: 0,
                                                            padding: 0,
                                                            '&.Mui-expanded': {
                                                                minHeight: 0,
                                                                margin: 0
                                                            },
                                                        }}

                                                    >
                                                        <AccordionSummary
                                                            aria-controls="panel1-content"
                                                            id="panel1-header"

                                                        >

                                                            <div key={index} className={styles['online_payment_method_card']}>
                                                                <div key={index} className={styles['online_payment_method_card_heading']}>
                                                                    <img src={getLogoByPaymentMethodName(pm?.paymentMethodName?.replaceAll("_", " "))} alt="credit card" />
                                                                    <h4>{pm?.paymentMethodName?.replaceAll("_", " ")}</h4>
                                                                </div>
                                                                <Radio sx={radioBtnStyle} checked={pm.id === paymentMethod.id} onChange={() => setPaymentMethod({ ...paymentMethod, id: pm.id, name: pm.paymentMethodName })} />
                                                            </div>
                                                        </AccordionSummary>
                                                        <AccordionDetails>
                                                            <Typography>
                                                                {pm?.payMethodDesc}
                                                            </Typography>
                                                        </AccordionDetails>
                                                    </Accordion>)}
                                            </div>}
                                    </React.Fragment>
                                )
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default FormPaymentOptions
